import Label from './Label';

export default Label;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/Label/index.js